module.exports = __webpack_public_path__ + "static/media/dollar-sign.46438164.png";